// Const
import { firmwareAvailabilitiesLabels } from '../const';

export const initDevicesTableData = ({
  selectedDevices
}) => {
  const devices = selectedDevices
    .map(device => {
      return {
        ...device,
        deviceName: device.name,
        firmwareAvailabilitiesLabel: firmwareAvailabilitiesLabels[device.firmwareAvailability],
      }
    })

  return devices;
}